import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=a6d5a8fc&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=a6d5a8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d5a8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d5a8fc')) {
      api.createRecord('a6d5a8fc', component.options)
    } else {
      api.reload('a6d5a8fc', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=a6d5a8fc&scoped=true&", function () {
      api.rerender('a6d5a8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/saleTrade/index.page.vue"
export default component.exports